import React, { Fragment, useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import foodOfferImg from "../../../assets/food/foodofferimg.png"
import stopwatch from "../../../assets/food/stopwatch.png"
import chooseYourOfferPvr from "../../../assets/food/choose-your-offer-pvr.svg"
import chooseYourOfferInox from "../../../assets/food/choose-your-offer-inox.svg"
import activateOfferToSeeQrPvr from "../../../assets/food/activate-offer-to-see-qr-pvr.svg"
import activateOfferToSeeQrInox from "../../../assets/food/activate-offer-to-see-qr-inox.svg"
import howQrCodePvr from "../../../assets/food/show-qr-code-pvr.svg"
import howQrCodeInox from "../../../assets/food/show-qr-code-inox.svg"
import closeIcon from "../../../assets/food/close.svg";
import { Modal } from 'react-bootstrap';
import FbHeader from '../component/FbHeader';
import { useDispatch, useSelector } from 'react-redux';
// import { addItemToCart } from '../redux/AddToCartSlice';
import { addToCart } from 'src/redux/actions/cartAction';
import { foodVoucher } from 'src/redux/actions/addToCartAction';
import { constantsTypes } from 'src/redux/reduxConstants';
import * as appConstants from "../../../constants/index";
import SweetAlertUtility from '../component/SweetAlertUtility';
import noImg from "../../../assets/food/foodofferimg.png";
import cartIcon from "../../../assets/food/cartIcon.svg";
import axios from 'axios';
import { formatDateWithOrdinal, formatExpiryDate } from '../component/commonFunction';

const FoodRedeem = () => {

    const [show, setShow] = useState(false);
    const [showTnC, setShowTnC] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isClosing, setIsClosing] = useState(false);
    const [isClosingTnC, setIsClosingTnC] = useState(false);
    const [showHowItsWork, setShowHowItsWork] = useState(false);
    const [isClosingHowItsWork, setIsClosingHowItsWork] = useState(false);
    const [inCart, setInCart] = useState(false);
    const [alertDetails, setAlertDetails] = useState({ show: false, type: '', title: '', message: '' });
    const { name } = useParams();

    const navigate = useNavigate();
    const AuthToken = sessionStorage.getItem("token") || " ";
    const theme = localStorage.getItem("theme");
    const city = localStorage.getItem("city");
    const offerCardData = JSON.parse(localStorage.getItem("foodoffers"));
    const theatreId = JSON.parse(localStorage.getItem("TheatreId"));
    const storeAllOfferData = JSON.parse(localStorage.getItem("storeAllOfferData")) || [];
    const cartCapacity = JSON.parse(localStorage.getItem("cartCapacity")) || [];
    const maxActivateLimit = JSON.parse(localStorage.getItem("maxActivateLimit")) || [];
    const cartOffers = JSON.parse(localStorage.getItem("cartOffers") || "[]").filter(item => item?.theatreId === theatreId);
    localStorage.setItem("promBanner", false);

    const handleCardClick = (e) => {
        setShow(true)
        setIsClosing(true)
    };

    const handleTnC = (type) => {
        if (type === "howtowork") {
            setShowHowItsWork(true);
            setIsClosingHowItsWork(true);
        } else {
            setShowTnC(true);
            setIsClosingTnC(true);
        }
    };

    const handleHide = () => {
        setIsClosing(true);
        setTimeout(() => {
            setIsClosing(false);
            setShow(false)
        }, 50);
    };


    const handleHideHowItsWork = () => {
        setIsClosingHowItsWork(true);
        setTimeout(() => {
            setIsClosingHowItsWork(false);
            setShowHowItsWork(false);
        }, 50);
    };

    const handleHideTnC = () => {
        setIsClosingTnC(true);
        setTimeout(() => {
            setIsClosingTnC(false);
            setShowTnC(false)
        }, 50);
    };

    useEffect(() => {
        const offerItems = cartOffers.some(data => data.voucherDesc?.replace(/[^a-zA-Z0-9\s.]/g, '').replace(/[\s.]+/g, '-').toLowerCase() === name);
        setInCart(offerItems)
    }, [cartOffers])

    useEffect(() => {
        setTimeout(() => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }, 300);
    }, [offerCardData]);

    const handleSelectedItems = (selectedItem, type) => {
        if (!selectedItem?.theatreId || !selectedItem?.voucherId) {
            sweetAlertError("Something went wrong!");
            return;
        }

        const { theatreId, voucherId } = selectedItem;
        const cartOffers = JSON.parse(localStorage.getItem("cartOffers") || "[]");

        const currentTheatreOffers = cartOffers.filter(offer => offer.theatreId === theatreId);
        const isAlreadyAdded = currentTheatreOffers.some(offer => offer.voucherId === voucherId);

        if (isAlreadyAdded) {
            navigate("/foodcart");
            return;
        }

        if (currentTheatreOffers.length >= cartCapacity) {
            sweetAlertWarning(`Maximum limit reached for this cinema.`);
            setShow(false);
            setIsClosing(false);
            return;
        }

        const updatedCart = [...cartOffers, { ...selectedItem, type }];
        localStorage.setItem("cartOffers", JSON.stringify(updatedCart));
        navigate("/foodcart");
    };


    const handleAddtoCart = () => {
        handleSelectedItems(offerCardData, "addtocart");
    };
    // const handleActivate = () => {
    //     const totalActive = storeAllOfferData.length;// + cartOffers.length;
    //     if (totalActive >= maxActivateLimit) {
    //         sweetAlertWarning(`Maximum voucher activation limit reached.`);
    //         return;
    //     }

    //     fetchActivate();
    // };

    const handleActivate = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${appConstants.base_url}v1/jito/active-voucher-count`,
                {
                    headers: {
                        Authorization: `Bearer ${AuthToken}`,
                        chain: theme === "inoxTheme" ? "INOX" : "PVR",
                        appVersion: appConstants.av,
                        platform: appConstants.pt,
                        city: city
                    }
                }
            );

            if (response.data.result.toLowerCase() === "success") {
                const totalActive = storeAllOfferData.length;
                if (response.data.output >= maxActivateLimit || totalActive >= maxActivateLimit) {
                    sweetAlertWarning(`Maximum voucher activation limit reached.`);
                    return;
                }
                fetchActivate();
            } else {
                sweetAlertError(response?.data?.msg);
            }
        } catch (error) {
            console.error("Error activating offer:", error);
            sweetAlertError("Failed to activate offer. Please try again.");
        } finally {
            setLoading(false);
        }
    };
    const fetchActivate = async () => {
        setLoading(true);
        try {
            const response = await axios.post(
                `${appConstants.base_url}v1/jito/activate-voucher`,
                {
                    ccode: theatreId,
                    vouId: [offerCardData.voucherId]
                },
                {
                    headers: {
                        Authorization: `Bearer ${AuthToken}`,
                        chain: theme === "inoxTheme" ? "INOX" : "PVR",
                        appVersion: appConstants.av,
                        platform: appConstants.pt,
                        city: city
                    }
                }
            );

            if (response.data.result.toLowerCase() === "success") {
                let newOffers = response.data.output;
                
                const selectedTheater = JSON.parse(localStorage.getItem("selectedTheater")) || [];
                const updatedNewOffers = newOffers.map(offer => ({
                    ...offer,
                    expiryDate: formatExpiryDate(offer.expiryDate),
                    activatedDate: formatExpiryDate(offer.activatedDate),
                    theatreId: parseInt(selectedTheater.theatreId),
                    theatreName: selectedTheater.name,
                    howToAvail: offerCardData?.howToAvail,
                    rules: offerCardData?.rules,
                    termCondition: offerCardData?.termCondition
                }));

                const mergedOffers = [
                    ...storeAllOfferData,
                    ...updatedNewOffers.filter(
                        newItem => !storeAllOfferData.some(existingItem => existingItem.voucherNo === newItem.voucherNo && newItem.theatreId === theatreId)
                    )
                ];
                // debugger
                localStorage.setItem("FoodActivated", JSON.stringify(updatedNewOffers));
                localStorage.setItem("storeAllOfferData", JSON.stringify(mergedOffers));
                navigate("/offeractivated");
            } else {
                sweetAlertWarning(response?.data?.msg);
            }
        } catch (error) {
            console.error("Error activating offer:", error);
            sweetAlertError("Failed to activate offer. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const sweetAlertError = (msg) => {
        setAlertDetails({
            show: true,
            type: 'error',
            title: 'Error!',
            message: msg,
        });
    };

    const sweetAlertWarning = (msg) => {
        setAlertDetails({
            show: true,
            type: 'warning',
            title: '',
            message: msg,
        });
    };

    const hideAlert = () => {
        // navigate("/food-Vouchers-at-boxoffice")
        setAlertDetails({ show: false });
    }

    const handleImageError = (e) => {
        e.target.src = noImg; // Set fallback image if the original image fails
    };

    // const addToCartText = () => {
    //     const offerItems = cartOffers.some(data => data.voucherDesc?.replace(/[^a-zA-Z0-9\s.]/g, '').replace(/[\s.]+/g, '-').toLowerCase() === name);
    //     setInCart(offerItems)
    //     // return offerItems ? "Go to Cart" : "Add to Cart"
    // }

    return (
        <>
            <FbHeader className="inrHdrPage dblock" headname="Redeem Offer" cartShow={true} />
            <div className='contentPage pb100'>
                <section className='offerRedeemPage'>
                    {/* {offerCardData && { */}
                    <Fragment key={offerCardData?.voucherNo}>
                        <div className="herobanner">
                            <img src={offerCardData.voucherImageUrl ? offerCardData.voucherImageUrl : noImg} width="100%" height={200} alt={offerCardData.voucherDesc} onError={handleImageError} />
                            {/* <svg className="cartVg" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="0.5" y="0.5" width="13" height="13" rx="1.5" stroke="#149752" />
                                            <circle cx="6.99984" cy="6.99935" r="4.08333" fill="#149752" />
                                        </svg> */}
                        </div>
                        <div className="rdmDisc">
                            <h4>{offerCardData.voucherDesc}</h4>
                            <p>Valid till {formatDateWithOrdinal(offerCardData.validTill, false)}</p>
                        </div>
                        {/* {offerCardData?.howToAvail?.length > 0 &&
                                        <div className="offerterms">
                                            {offerCardData.howToAvail.some(avail => avail?.header) ? (
                                                <h4>{offerCardData.howToAvail.find(avail => avail?.header)?.description}</h4>
                                            ) : (
                                                <h4>How to Avail</h4>
                                            )}


                                            <ol className="termsul">
                                                {offerCardData.howToAvail
                                                    .filter(avail => avail?.header === false)
                                                    .map((avail, index) => (
                                                        <li key={index}>{avail.description}</li>
                                                    ))}
                                            </ol>
                                        </div>
                                    } */}
                        <div className="offerterms">
                            <h4>Rules</h4>
                            {offerCardData?.rules?.slice(1)?.map(rule => (
                                <div className="rlsflx">
                                    <span>{rule?.description}</span>
                                </div>
                            ))}
                        </div>
                        <div className="offerterms">
                            <div className="rlsMain">
                                <svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.99996 17.3334C4.39746 17.3334 0.666626 13.6026 0.666626 9.00008C0.666626 4.39758 4.39746 0.666748 8.99996 0.666748C13.6025 0.666748 17.3333 4.39758 17.3333 9.00008C17.3333 13.6026 13.6025 17.3334 8.99996 17.3334ZM8.99996 15.6667C10.7681 15.6667 12.4638 14.9644 13.714 13.7141C14.9642 12.4639 15.6666 10.7682 15.6666 9.00008C15.6666 7.23197 14.9642 5.53628 13.714 4.28604C12.4638 3.03579 10.7681 2.33341 8.99996 2.33341C7.23185 2.33341 5.53616 3.03579 4.28591 4.28604C3.03567 5.53628 2.33329 7.23197 2.33329 9.00008C2.33329 10.7682 3.03567 12.4639 4.28591 13.7141C5.53616 14.9644 7.23185 15.6667 8.99996 15.6667ZM8.16663 11.5001H9.83329V13.1667H8.16663V11.5001ZM9.83329 10.1292V10.6667H8.16663V9.41675C8.16663 9.19573 8.25442 8.98377 8.4107 8.82749C8.56698 8.67121 8.77895 8.58342 8.99996 8.58342C9.23669 8.5834 9.46855 8.51616 9.66856 8.38952C9.86858 8.26288 10.0285 8.08205 10.1298 7.86807C10.231 7.65408 10.2694 7.41574 10.2405 7.18078C10.2116 6.94582 10.1166 6.7239 9.96649 6.54084C9.81639 6.35778 9.61739 6.22111 9.39264 6.14672C9.1679 6.07234 8.92666 6.0633 8.69698 6.12067C8.4673 6.17803 8.25864 6.29944 8.09527 6.47076C7.93189 6.64208 7.82053 6.85628 7.77413 7.08842L6.13913 6.76091C6.24049 6.25432 6.47455 5.78372 6.81739 5.39724C7.16024 5.01075 7.59956 4.72223 8.09045 4.56118C8.58134 4.40013 9.1062 4.37232 9.61136 4.48059C10.1165 4.58887 10.5839 4.82934 10.9656 5.17744C11.3474 5.52553 11.6299 5.96875 11.7842 6.4618C11.9385 6.95485 11.9592 7.48004 11.844 7.98367C11.7288 8.48731 11.482 8.95133 11.1287 9.3283C10.7754 9.70527 10.3284 9.98167 9.83329 10.1292Z" fill="black" />
                                </svg>
                                <div className="inrdev">
                                    <h4 onClick={() => handleTnC("howtowork")} style={{ textDecoration: "underline" }}>How it Works?</h4>
                                    <p>Know how to avail this offer</p>
                                </div>
                            </div>
                            <div className="rlsflx hwIcon">
                                <div className="hwInnr">
                                    <div className="rlsImg">
                                        <img src={theme === "inoxTheme" ? chooseYourOfferInox : chooseYourOfferPvr} width={50} height={50} alt="Choose your offer" />
                                    </div>
                                    <p>Select Offer</p>
                                </div>
                                <div className="hwInnr">
                                    <div className="rlsImg">
                                        <img src={theme === "inoxTheme" ? activateOfferToSeeQrInox : activateOfferToSeeQrPvr} width={50} height={50} alt="Activate offer to see QR" />
                                    </div>
                                    <p>Activate Offer</p>
                                </div>
                                <div className="hwInnr">
                                    <div className="rlsImg">
                                        <img src={theme === "inoxTheme" ? howQrCodeInox : howQrCodePvr} width={50} height={50} alt="Show QR at cinemas F&B counter to redeem within 15-minutes" />
                                    </div>
                                    <p>Redeem at cinema counter</p>
                                </div>
                            </div>
                            {/* <div className="rlsflx hwIcon">
                                <div className="rlsImg">
                                    <img src={theme === "inoxTheme" ? activateOfferToSeeQrInox : activateOfferToSeeQrPvr} width={50} height={50} alt="Activate offer to see QR" />
                                </div>
                                <span>Activate offer to see QR</span>
                            </div>
                            <div className="rlsflx hwIcon">
                                <div className="rlsImg">
                                    <img src={theme === "inoxTheme" ? howQrCodeInox : howQrCodePvr} width={50} height={50} alt="Show QR at cinemas F&B counter to redeem within 15-minutes" />
                                </div>
                                <span>Show QR at cinema F&B counter to place order.</span>
                            </div> */}
                        </div>


                        {offerCardData?.termCondition?.length > 0 && <p className="tncdetal" onClick={handleTnC}>Terms & Conditions</p>}

                        {/* {offerCardData?.termCondition?.length > 0 &&
                                        <div className="offerterms">
                                            <h4>Term & Conditions</h4>
                                            <ul className='termsul'>
                                                {offerCardData?.termCondition?.map((terms) => (
                                                    <li>{terms.replace("•\t", "")}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    } */}
                        {!offerCardData?.active && <div className="fixbtmbtn">
                            {inCart &&
                                <div className='incartPrt'>
                                    <img src={cartIcon} alt="" />
                                    <span>In Cart</span>
                                </div>
                            }
                            <Link className="cmnbtn" onClick={handleCardClick}>REDEEM</Link>
                        </div>}
                    </Fragment>
                </section>
            </div>

            <Modal className='slideTopModal tncModal'
                show={showHowItsWork || isClosingHowItsWork}
                onHide={handleHideHowItsWork}
                animation={false}
                keyboard={false}
                dialogClassName={isClosingTnC ? "modal-dialog modal-hide" : "modal-dialog"}
                style={{ backgroundColor: "rgba(0,0,0,0.7)", overflow: "hidden" }}
            >
                <div className="tnchdr">
                    <div></div>
                    <span className="Cus-itemspan">{offerCardData?.howToAvail[0]?.description}</span>
                    <img
                        style={{ cursor: "pointer" }}
                        onClick={handleHideHowItsWork}
                        src={closeIcon}
                        alt="close"
                    />
                </div>

                <ul className='termsul'>
                    {offerCardData?.howToAvail?.slice(1)?.map((terms) => (
                        <li>{terms?.description}</li>
                    ))}
                </ul>
                <button className='fb-added-btn' onClick={handleHideHowItsWork} style={{ width: "100%" }}>Ok</button>
            </Modal>

            <Modal className='slideTopModal tncModal'
                show={showTnC || isClosingTnC}
                onHide={handleHideTnC}
                animation={false}
                keyboard={false}
                dialogClassName={isClosingTnC ? "modal-dialog modal-hide" : "modal-dialog"}
                style={{ backgroundColor: "rgba(0,0,0,0.7)", overflow: "hidden" }}
            >
                <div className="tnchdr">
                    <div></div>
                    <span className="Cus-itemspan">Terms & conditions</span>
                    <img
                        style={{ cursor: "pointer" }}
                        onClick={handleHideTnC}
                        src={closeIcon}
                        alt="close"
                    />
                </div>
                {/* <div className="m-offer-hdiv">
                                <div
                                className="m-cus-head"
                                style={{ padding: 0, borderBottom: 0 }}
                                >
                                <span className="Cus-itemspan">{offerCardData.voucherDesc}</span>
                                <img
                                onClick={handleHideTnC}
                                src={closeIcon}
                                alt="close"
                                style={{ cursor: "pointer" }}
                                />
                                </div>
                                
                                <p className="m-offer-ptag">
                                Valid till {formatDateWithOrdinal(offerCardData.validTill, false)}
                                </p>
                                </div> */}

                <ul className='termsul'>
                    {offerCardData?.termCondition?.map((terms) => (
                        <li>{terms.replace("•\t", "")}</li>
                    ))}
                </ul>
                <button className='fb-added-btn' onClick={handleHideTnC} style={{ width: "100%" }}>Accept</button>
            </Modal>

            <Modal className='slideTopModal rdmOfr'
                show={show || isClosing}
                onHide={handleHide}
                animation={false}
                keyboard={false}
                dialogClassName={isClosing ? "modal-dialog modal-hide" : "modal-dialog"}
                style={{ backgroundColor: "rgba(0,0,0,0.7)", overflow: "hidden" }}
            >
                <div className="modalbody">
                    <img src={stopwatch} alt="" />
                    <h3 className='rdmTitle'>Redeem in <strong>15 minutes</strong></h3>
                    <p>Once activated, redeem the QR Code at F&B counter within 15 minutes.</p>
                    <div className="fdrdmbtn">
                        <button className='modalbtn offermdbtn addtocartbtn' onClick={() => handleAddtoCart()}>{inCart ? "Go to Cart" : "Add to Cart"}</button>
                        <button className='modalbtn offermdbtn actibtn' onClick={() => handleActivate()}>Activate</button>
                    </div>
                </div>
            </Modal>


            <SweetAlertUtility type={alertDetails.type} title={alertDetails.title} message={alertDetails.message} show={alertDetails.show} onConfirm={hideAlert} />
        </>

    )
}

export default FoodRedeem
